import {
    get,
    post,
    put
} from "./http";
import qs from 'qs'



//首页---顶部信息
export const topInfo = (params) => {
    let url = "/jysk/brain/industrial/index/top/info";
    return get(url, params);
}

//首页---产品检索器-产品参数列表
export const listGlobal = (params) => {
    let url = "/jysk/brain/industrial/list/retrieval/global";
    return get(url, params);
}

//首页---价格指数-产品类型列表-筛选用
export const productTypeList = (params) => {
    let url = "/jysk/brain/industrial/list/product/type/global";
    return get(url, params);
}

//首页---价格指数-产品类型列表-筛选用
export const exponentLeft = (params) => {
    let url = "/jysk/synergy/industry/index/exponent/left";
    return get(url, params);
}

//首页---价格指数-右侧线条
export const exponentRight = (params) => {
    let url = "/jysk/synergy/industry/index/exponent/right";
    return get(url, params);
}

//首页---新闻列表--new
export const homeArticleList = (params) => {
    let url = "/jysk/synergy/industry/index/article/list";
    return get(url, params);
}

//每日焦易--供应市场
export function supplyMarket(params) {
    let url = "/jysk/synergy/industry/supply/market/list";
    return post(url, params);
}

//每日焦易--需求市场
export function demandMarket(params) {
    let url = "/jysk/synergy/industry/demand/market/list";
    return post(url, params);
}

//每日焦易--详情
export function supplyDemandInfo(params) {
    let url = "/jysk/synergy/industry/supply/demand/Info";
    return get(url, params);
}



